import styles from "./checkoutshipping.module.css";

const CheckoutShipping = ({
  shippingRules = [],
  selectedShipping,
  setSelectedShipping,
  subtotal,
}) => {


  if (!shippingRules || shippingRules.length === 0) {
    return null;
  }

  const getShippingCost = (rule) => {
    if (!rule) return 0;

    if (rule.type === "flat_cost") {
      return Number(rule.cost);
    }

    if (rule.type === "min_cost") {
      return Number(subtotal) >= Number(rule.min_cost)
        ? 0
        : Number(rule.cost);
    }

    return 0;
  };

  return (
    <div className={styles.shippingBox}>

      {/* TITLE */}
      <div className={styles.shippingTitle}>
        Select Shipping Method
      </div>

      {/* SHIPPING OPTIONS */}
      <div className={styles.shippingOptions}>
        {shippingRules.map((rule) => {
      const disableRule =
  rule.type === "min_cost" &&
  Number(subtotal) < Number(rule.min_cost || 0);

          const shippingCost = getShippingCost(rule);

          return (
            <label
              key={rule.id}
              className={`
                ${styles.shippingOption}
                ${
                  selectedShipping?.id === rule.id
                    ? styles.selectedOption
                    : ""
                }
                ${disableRule ? styles.disabledOption : ""}
              `}
            >
              <input
                type="radio"
                name="shipping"
                value={rule.id}
                disabled={disableRule}
                checked={selectedShipping?.id === rule.id}
                onChange={() => setSelectedShipping(rule)}
              />

              <div className={styles.optionContent}>
                <span className={styles.optionName}>
                  {rule.name}
                </span>

                <span className={styles.optionPrice}>
                  {rule.type === "flat_cost"
                    ? `₹${Number(rule.cost).toFixed(2)}`
                    : `Free above ₹${Number(rule.min_cost).toFixed(2)}`}
                </span>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default CheckoutShipping;